module.exports = __webpack_public_path__ + "static/media/PigsFeet.49500271.png";